<template>
<div class="share-button">
  <p class="share-button__caption">{{ $translate('share') }}</p>

  <button class="share-button__button" @click="share">
    <span class="share-button__bg" />
    <img src="/assets/svg/share-icon.svg" alt="Share icon button" data-icon>
  </button>

  <a style="display: none" ref="link" href="" download></a>
</div>
</template>

<script>
export default {
  name: 'ButtonShare',

  methods: {
    async share() {
      this.$sendEvent('Share Icon', 'share_your_result');
      let url = '';

      if (this.$inApp) {
        url = await this.$game.generateShareImage();
        const encoded = encodeURIComponent(url);
        window.location.href = `arcade://share?url=${encoded}`;
      } else {
        url = await this.$game.generateShareImage();
        this.$refs.link.href = url;
        this.$refs.link.click();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.share-button {
  flex-flow: column nowrap;
  pointer-events: auto;

  &,
  &__button {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__caption {
    margin-bottom: 5px;
    font-weight: normal;

    @extend %font-small;

    @include mq($until: mobileL) {
      margin-bottom: 12px;
    }
  }

  &__button {
    position: relative;
    width: 4.5vw;
    height: 4.5vw;
    min-width: 50px;
    max-width: 90px;
    min-height: 50px;
    max-height: 90px;

    background-color: transparent;
    cursor: pointer;
  }

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-color: $color-ui;
    border-radius: 50%;
    box-shadow: $button-shadow;

    @extend %grain;
  }

  img {
    display: block;
    position: relative;
    width: 40%;
    margin-top: -10%;
  }

  @include mq(ipadP, $and: $is-not-touch-device) {
    &__caption {
      margin-bottom: 18px;
    }

    img {
      margin-top: -6%;
    }
  };

  @include mq($and: $is-not-touch-device) {
    &__bg {
      transition: transform 0.5s $flap;
    }
    &:hover &__bg {
      transform: scale(1.1);
    }
  }
}
</style>
